import { useCallback, useMemo } from 'react';
import useSWR, { SWRConfiguration } from 'swr';
import { ListaIdCursosComplementaresHook } from './lista-ids-cursos-complementares.types';

// meia hora em milissegundos
const TEMPO_DEDUPING = 1800000;

export const useListaIdsCursosComplementares: ListaIdCursosComplementaresHook =
  ({ precondicao, fonteDados, onSucessoRequisicao }) => {
    const onSuccessConfigOptional: SWRConfiguration = onSucessoRequisicao
      ? { onSuccess: onSucessoRequisicao }
      : {};

    const { data, error, isValidating, mutate } = useSWR(
      precondicao() ? 'cursos-complementares' : null,
      fonteDados,
      {
        revalidateOnReconnect: false,
        revalidateOnMount: true,
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        dedupingInterval: TEMPO_DEDUPING,
        ...onSuccessConfigOptional,
      },
    );

    const erro = !!error;

    const pendente = useMemo(
      () => (!data && !erro) || (erro && isValidating),
      [data, erro, isValidating],
    );

    const retentar = useCallback(() => {
      mutate();
    }, [mutate]);

    return useMemo(
      () => ({
        codigosCursos: data ?? [],
        pendente,
        error: error ?? null,
        retentar,
      }),
      [data, error, pendente, retentar],
    );
  };
